import { Menu } from '../types/menu'

// Autosaves the menu being edited in this browser so a refresh doesn't lose work.
// Browser storage can be unavailable (private mode, blocked storage), so every
// call fails quietly and the app keeps working without it.

const STORAGE_KEY = 'text-to-table:draft:v1'

export interface MenuDraft {
  menu: Menu
  savedAt: Date
}

export function saveDraft(menu: Menu): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ menu, savedAt: new Date().toISOString() }))
  } catch {
    // Storage full or blocked: skip autosave
  }
}

export function loadDraft(): MenuDraft | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const data = JSON.parse(raw)
    const menu = data?.menu
    if (!menu || !Array.isArray(menu.sections) || !menu.theme) return null
    return {
      menu: {
        ...menu,
        createdAt: new Date(menu.createdAt),
        lastModified: new Date(menu.lastModified),
      },
      savedAt: new Date(data.savedAt),
    }
  } catch {
    return null
  }
}

export function clearDraft(): void {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    // Nothing to clear
  }
}
